import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AccountTypeList,
  ActionType,
  DepreciationMethodType,
  DisposalType,
  Modules,
  NotificationTextMessage,
} from '@app/core/Enum';
import {
  FixedAssetDisposeModel,
  GlobalComponent,
  VatRateScheme,
} from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import {
  CreateFixedAssetDispose,
  GetCustomBankAndCashAccount,
  GetDepreciationChargeByDate,
  GetFixedAssetDispose,
  GetVatRateList,
} from '@app/core/Store';
import { Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-edit-dispose-asset',
  templateUrl: './edit-dispose-asset.component.html',
  styleUrls: ['./edit-dispose-asset.component.scss'],
})
export class EditDisposeAssetComponent implements OnInit {
  explainId = Guid.EMPTY as unknown as Guid;
  moduleId : number;
  showVATApplicable = false;
  methodTypeList = DepreciationMethodType;

  disposeDetailData: any;
  depreciationCharge: any;
  maxEndDate: Date;
  minStartDate: Date;
  totalProfitLoss: number = 0;
  disposeSellType: number;
  actionType = ActionType;
  accountTypeList = AccountTypeList;
  vatRateList: VatRateScheme[];
  accountsList: any[] = [];
  fixedAssetDisposeData: FixedAssetDisposeModel;
  lossProfitLable: string;
  assetDisposeForm: FormGroup;
  isVatRegistered: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<EditDisposeAssetComponent>,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    private globalComponent: GlobalComponent
  ) {
    this.explainId =
      data.id === undefined
        ? (Guid.EMPTY as unknown as Guid)
        : (atob(data.id!) as unknown as Guid);
    this.maxEndDate = new Date();
    this.disposeSellType = data.actionType;
  }

  ngOnInit(): void {
     this.moduleId = this.data.moduleId;
    
    this.isVatRegistered = this.globalComponent.getIsVatRegistered();
    this.setForm();
    this.getFixedAssetDispose();
    this.spinner.show();
  }

  setForm(): void {
    this.assetDisposeForm = new FormGroup({
      acquiredDate: new FormControl({ value: '', disabled: true }),
      price: new FormControl({ value: '', disabled: true }),
      depreciationMethod: new FormControl({ value: '', disabled: true }),
      rate: new FormControl({ value: '', disabled: true }),
      depreciationCharged: new FormControl({ value: '', disabled: true }),
      date: new FormControl('', [Validators.required]),
      depreciationCharge: new FormControl({ value: '', disabled: true }),
      account: new FormControl('', [Validators.required]),
      disposePrice: new FormControl(''),
      notes: new FormControl(''),
      fundId: new FormControl(''),
      fundName: new FormControl({ value: '', disabled: true }),
      salePrice: new FormControl('', [Validators.required]),
      isVATApplicable: new FormControl(''),
      vat: new FormControl(''),
      vatRate: new FormControl({ value: '', disabled: true }),
      netSalePrice: new FormControl({ value: '', disabled: true }),
      totalProfit: new FormControl({ value: 0, disabled: true }),
    });
    this.getVatRateList();
    this.getAccountList();
  }

  getVatRateList(): void {
    this.store.dispatch(new GetVatRateList()).subscribe((res) => {
      this.vatRateList = res.common.vatRate;
    });
  }

  getAccountList(): void {
    this.store
      .dispatch(new GetCustomBankAndCashAccount())
      .pipe(
        tap((res) => {
          this.accountsList = res.common.customBankAndCashAccount;
        })
      )
      .subscribe();
  }

  getFixedAssetDispose(): void {
    this.store
      .dispatch(new GetFixedAssetDispose(this.explainId))
      .subscribe((res) => {
        this.disposeDetailData = res.fixedAssetRegister.disposeDetailData;
        this.editFixedAssetDisposeDetails(this.disposeDetailData);
      });
  }

  getOptionText(option) {
    return option.name;
  }

  editFixedAssetDisposeDetails(data): void {
    this.minStartDate = data.entryDate;
    this.showVATApplicable = !!data.isVATApplicable;
    const specificDate = new Date(data.lastDepreciate);
    const maxDateOnly = new Date(this.maxEndDate);
    maxDateOnly.setHours(0, 0, 0, 0);
    specificDate.setHours(0, 0, 0, 0);

    if (specificDate < maxDateOnly) {
      specificDate.setDate(specificDate.getDate() + 1);
    }

    this.minStartDate = specificDate;
    this.assetDisposeForm.patchValue({
      acquiredDate: data.entryDate,
      price: data.totalAmount,
      depreciationMethod: data.methodTypeId,
      rate: data.rate,
      depreciationCharged: data.totalDepreciation,
      date: data.disposeDate === null ? new Date() : data.disposeDate,
      depreciationCharge: this.depreciationCharge,
      account: data.transactionAccountId,
      disposePrice: data.disposalType,
      notes: data.description,
      fundId: data.fundId,
      fundName: data.fundName,
      vat: data.vatRateId,
      vatRate: data.vatAmount,
      netSalePrice: data.amountSold,
      isVATApplicable: data.isVATApplicable,
      totalProfit: data.totalProfit,
       method: data.methodTypeId,
    });
     if (data.methodTypeId === 2) {
      this.isRate = false;
    } else if (data.methodTypeId === 1) {
      this.isRate = true;
    } else {
      this.isRate = false;
    }
    this.getDepreciationChargeByDate();
  }

  getDepreciationChargeByDate() {
    let date: any = moment(this.assetDisposeForm.controls.date.value.valueOf())
      .format('yyyy-MM-DD')
      .toString();
    this.store
      .dispatch(
        new GetDepreciationChargeByDate(this.disposeDetailData.id, date)
      )
      .subscribe((res) => {
        this.depreciationCharge = res.fixedAssetRegister.depreciationChargeDate;
        this.assetDisposeForm.controls.depreciationCharge.setValue(
        this.depreciationCharge
      );
       this.getTotalProfitLoss();
      });
   
  }

  getTotalProfitLoss() {
    if (this.disposeSellType === ActionType.Sell) {
      this.calVatAmount();
    } else {
      this.assetDisposeForm.get('account')?.clearValidators();
      this.assetDisposeForm.get('salePrice')?.clearValidators();
      this.assetDisposeForm.get('account')?.updateValueAndValidity();
      this.assetDisposeForm.get('salePrice')?.updateValueAndValidity();
      const totalProfit =
       ((+this.disposeDetailData.totalDepreciation) +
       (+this.depreciationCharge))- ( +this.disposeDetailData.totalAmount);
      this.assetDisposeForm.controls.totalProfit.setValue(
       Math.abs(totalProfit).toFixed(2)
      );
      this.lossProfitLable = totalProfit < 0 ? 'Loss' : 'Profit';
    }
  }

  onDepreciableAsset(event: any): void {
    this.showVATApplicable = event.checked;
    this.assetDisposeForm.controls.isVATApplicable.setValue(event.checked);
    if (event.checked) {
      this.getTotalProfitLoss();
    } else {
      this.getTotalProfitLoss();
    }
  }

  onSave(): void {
    if (this.assetDisposeForm.invalid) {
      this.assetDisposeForm.markAllAsTouched();
      return;
    } else {
      if (this.dataSubmit()) {
        if (this.fixedAssetDisposeData) {
          this.store
            .dispatch(new CreateFixedAssetDispose(this.fixedAssetDisposeData))
            .pipe()
            .subscribe(
              (res) => {
                if (res !== undefined) {
                  this.commonService.onSucess(
                    NotificationTextMessage.successMessage
                  );
                  this.dialogRef.close();
                } else {
                  this.commonService.onFailure(
                    NotificationTextMessage.errorMessage
                  );
                }
              },
              (err) => {
                this.commonService.onFailure(err.error.Message);
              }
            );
        }
      }
    }
  }

  dataSubmit(): boolean {
    this.spinner.show();
    try {
      this.fixedAssetDisposeData = {
        id: this.disposeDetailData.id,
        fundId: this.assetDisposeForm.controls.fundId.value,
        name: this.disposeDetailData.name,
        referenceTypeId: this.disposeDetailData.referenceTypeId,
        bookAccountId: this.disposeDetailData.bookAccountId,
        referenceId: this.disposeDetailData.referenceId,
        methodTypeId: this.disposeDetailData.methodTypeId,
        rate: this.disposeDetailData.rate,
        isDepreciable: this.disposeDetailData.isDepreciable,
        totalAmount: this.disposeDetailData.totalAmount,
        totalDepreciation: this.disposeDetailData.totalDepreciation,
        currentDepreciation:
          +this.assetDisposeForm.controls.depreciationCharge.value,
        entryDate: this.disposeDetailData.entryDate,
        isDisposed: true,
        disposalType:
          this.disposeSellType === ActionType.Sell
            ? DisposalType.Sell
            : DisposalType.Disposed,
        disposeDate: this.assetDisposeForm.controls.date.value,
        amountSold:
          this.assetDisposeForm.controls.salePrice.value === ''
            ? null
            : this.assetDisposeForm.controls.salePrice.value,
        amountLoss: this.disposeDetailData.amountLoss,
        description: this.assetDisposeForm.controls.notes.value,
        transactionAccountId: this.assetDisposeForm.controls.account.value,
        disposeJournalId: this.disposeDetailData.disposeJournalId,
        transactionJournalId: this.disposeDetailData.transactionJournalId,
        isVATApplicable: this.showVATApplicable,
        vatRateId: this.showVATApplicable
          ? this.assetDisposeForm.controls.vat.value
          : null,
        vatAmount: this.showVATApplicable
          ? this.assetDisposeForm.controls.vatRate.value
          : null,
        netAmount: +this.assetDisposeForm.controls.totalProfit.value,
        isTangible: this.data?.isTangible ? true : false,
      };
    } catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  onCancel(): void {
    if (!this.commonService.isEmpty(this.explainId)) {
      this.getFixedAssetDispose();
    } else {
      this.explainId = Guid.EMPTY as unknown as Guid;
      this.ngOnInit();
    }
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  scrollIntoView(element) {
    if (element !== '') {
      this.commonService.autoScrollMatAutoComplete(this.renderer);
    }
  }

  calVatAmount(): void {
    const salePrice = +this.assetDisposeForm.controls.salePrice.value || 0;
    const depreciationCharge =
      this.assetDisposeForm.controls.depreciationCharge.value !== undefined &&
      this.assetDisposeForm.controls.depreciationCharge.value !== null &&
      this.assetDisposeForm.controls.depreciationCharge.value !== ''
        ? +this.assetDisposeForm.controls.depreciationCharge.value
        : this.depreciationCharge
        ? +this.depreciationCharge
        : 0;

    const totalProfit =
      +this.disposeDetailData.totalAmount -
      +this.disposeDetailData.totalDepreciation -
      depreciationCharge;

    if (!this.showVATApplicable) {
      const grossProfitLoss = Math.abs(
        +this.disposeDetailData.totalDepreciation +
          depreciationCharge +
          salePrice -
          +this.disposeDetailData.totalAmount
      );

      this.assetDisposeForm.controls.vatRate.setValue('');
      this.assetDisposeForm.controls.netSalePrice.setValue('');
      this.totalProfitLoss = grossProfitLoss;
      this.assetDisposeForm.controls.totalProfit.setValue(
        grossProfitLoss.toFixed(2)
      );
      this.lossProfitLable = salePrice < totalProfit ? 'Loss' : 'Profit';
      return;
    }

    let vatRate = 0;

    if (this.vatRateList.length > 0) {
      this.vatRateList.forEach((element) => {
        if (element.id === this.assetDisposeForm.controls.vat.value) {
          vatRate = element.rate;
        }
      });

      const vatAmount =
        salePrice - (salePrice * 100) / (100 + vatRate);
      const netSalePrice = salePrice - vatAmount;
      const totalProfitLoss = Math.abs(
        +this.disposeDetailData.totalDepreciation +
          depreciationCharge +
          netSalePrice -
          +this.disposeDetailData.totalAmount
      );

      this.assetDisposeForm.controls.vatRate.setValue(+vatAmount.toFixed(2));
      this.assetDisposeForm.controls.netSalePrice.setValue(
        +netSalePrice.toFixed(2)
      );
      this.totalProfitLoss = totalProfitLoss;
      this.assetDisposeForm.controls.totalProfit.setValue(
        totalProfitLoss.toFixed(2)
      );
      this.lossProfitLable =
        netSalePrice < totalProfit ? 'Loss' : 'Profit';
    }
  }
isRate = true;
  methodChange(event: any): void {
    if (event === 2) {
      this.isRate = false;
    } else if (event === 1) {
      this.isRate = true;
    } else {
      this.isRate = false;
    }
  }
}
